var versions = [
    '1.0.0'
];

function load(version) {
    // Use the last version availiable here
    return require('./1.0.0/reference.json');
}

module.exports = {
    versions: versions,
    load: load
}


//////////////////
// WEBPACK FOOTER
// ./~/tangram-reference/index.js
// module id = 1075
// module chunks = 6